import { VueConstructor } from 'vue'

export default ({ app, Vue }: { app: any; Vue: VueConstructor }) => {
  // @ts-ignore
  if (window.Cypress) {
    // @ts-ignore
    window.app = new Vue(app)
  }
}
